import React from 'react'

import Link from 'components_new/atoms/Link'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { addRef } from 'utils/queryHandler'
import { Context } from 'types/GlobalUserEvents'

interface InvalidMetricsProps {
  metrics: { id: string; title: string }[]
}

const InvalidMetrics = (props: InvalidMetricsProps) => {
  const { metrics } = props

  const { isAdmin } = useAccountSettings()

  return (
    <ul>
      {metrics.map((item, i) => (
        <React.Fragment key={item.id}>
          {isAdmin ? (
            <li>
              <Link
                href={`/metrics/${item.id}`}
                search={addRef('', Context.FROM_WIDGET)}
              >
                {item.title}
              </Link>
            </li>
          ) : (
            <li>
              <b>{item.title}</b>
            </li>
          )}
          {metrics.length - 1 > i ? ', ' : ''}
        </React.Fragment>
      ))}
    </ul>
  )
}

export default InvalidMetrics
